import React from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { isView } from '../../../../core/page/components/baseForm/BaseForm';
import { isEmpty } from '../../../../core/utils/ValidForm';
import Pages from '../../../../config/Pages';
import Shareds from '../../../../config/translations/Shareds';
import CardSeplag from '../../../../components/cardSeplag/CardSeplag';
import styles from './PropostaIndicadorForm.module.scss';
import { Button } from 'primereact/button';
import MultipageProposta from '../components/MultipageProposta';
import LinkTo from '../../../../core/components/LinkTo';

function PropostaIndicadorForm() {
    const { id } = useParams();
    const history = useHistory();

    return (
        <CardSeplag
            title={Pages.sei.propostaIndicador.title}
            classHeader={styles.header}
            afterComponent={
                !isEmpty(id) && (
                    <LinkTo to={Pages.sei.statusProposta.url.list.replace(':id', id)}>
                        <Button
                            className={`p-button p-button-help ${styles.buttonStatus}`}
                            icon="pi pi-arrow-right-arrow-left"
                            type="button"
                            label="Status"
                        />
                    </LinkTo>
                )
            }
            legenda={() => {
                if (isView()) {
                    return Shareds.form.actions.view;
                } else {
                    return isEmpty(id) ? Shareds.form.actions.create : Shareds.form.actions.update;
                }
            }}
        >
            <MultipageProposta
                idProposta={id}
                className={styles.card}
                isView={isView()}
                onEnviar={() =>
                    history.push(Pages.sei.propostaIndicador.url.view.replace(':id', id))
                }
                onSaveDadosGerais={({ success, response }) => {
                    if (success && isEmpty(id)) {
                        setTimeout(() => {
                            history.push(
                                `${Pages.sei.propostaIndicador.url.edit.replace(
                                    ':id',
                                    response?.id
                                )}`
                            );
                        }, 500);
                    }
                }}
            />
        </CardSeplag>
    );
}

export default PropostaIndicadorForm;
